export default {
  en: {
    close: 'close',
    info: 'more information'
  },
  fi: {
    close: 'sulje',
    info: 'lisätietoja'
  },
  sv: {
    close: 'stäng',
    info: 'tilläggsuppgifter'
  }
};